var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-4 my-6 mx-9 rounded-lg",attrs:{"flat":"","color":"#f5f7f7"}},[_c('div',{attrs:{"id":"bar-chart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }